import { Button, Popconfirm, Segmented, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { BorderColorOutlined } from "@mui/icons-material";
import moment from "moment";
import { MdOutlineNotificationsNone } from "react-icons/md";
import BonusCard from "../DealerBonus/BonusCard";

const arrayToObject = (arr) => {
  let finalObj = {};
  arr.forEach((elem, i) => {
    finalObj[`${elem?.id}`] = "after_update";
  });
  return finalObj;
};
const CheckPropertinChanges = (array, it) => {
  return (
    Object.keys(array)?.includes(`year${it}_fee`) ||
    Object.keys(array)?.includes(`year${it}_status`)
  );
};

const NotificationContent = (props) => {
  const { selectedNotification, activeTab, setActiveTab } = props;
  const [commissionSegment, setCommissionSegment] = useState(
    selectedNotification?.updated_information !== undefined
      ? arrayToObject(selectedNotification?.updated_information)
      : {}
  );
  console.log("commissionSegment", commissionSegment);

  useEffect(() => {
    if (selectedNotification?.updated_information?.length > 0) {
      setCommissionSegment(
        arrayToObject(selectedNotification?.updated_information)
      );
    }
  }, [selectedNotification?.updated_information]);

  const GetChanges = (array) => {
    let temp = selectedNotification?.updated_information?.map(
      (notification, index) =>
        notification?.loginfo?.changes?.interest_changes?.map(
          (it) => it?.interest
        )
    );
  };

  useEffect(() => {
    if (selectedNotification?.updated_information?.length > 0) {
      GetChanges();
      const obj = {};
      let temp = selectedNotification?.updated_information.map((item) => ({
        [item?.id]: 0,
      }));
      for (let i = 0; i < temp.length; i++) {
        Object.assign(obj, temp[i]);
      }
      setActiveTab(obj);
    }
  }, [selectedNotification?.updated_information]);

  const GetCategory = (categoryType, name) => {
    switch (categoryType) {
      case "category":
        return (
          <div className="p-[5px_10px] text-[12px] text-[#27AE60] rounded-[4px] border border-[#27AE60] bg-[#DBFFDE] flex items-center gap-[8px]">
            <img
              src="/images/category_clr_ic.png"
              alt="icon"
              className="w-[15px]"
            />
            {name}
          </div>
        );
      case "type":
        return (
          <div className="p-[5px_10px] text-[12px] text-[#EB860F] rounded-[4px] border border-[#EB860F] bg-[#FFECD7] flex items-center gap-[8px]">
            <img
              src="/images/type_clr_ic.png"
              alt="icon"
              className="w-[15px]"
            />
            {name}
          </div>
        );
      case "scheme":
        return (
          <div className="p-[5px_10px] text-[12px] text-[#F80707] rounded-[4px] border border-[#F80707] bg-[#FFECEC] flex items-center gap-[8px]">
            <img
              src="/images/scheme_clr_ic.png"
              alt="icon"
              className="w-[15px]"
            />
            {name}
          </div>
        );
      case "motor_type":
        return (
          <div className="p-[5px_10px] text-[12px] text-[#0560FB] rounded-[4px] border border-[#0560FB] bg-[#DDEAFF] flex items-center gap-[8px]">
            <img
              src="/images/motor_clr_ic.png"
              alt="icon"
              className="w-[15px]"
            />
            {name}
          </div>
        );
      case "usage":
        return (
          <div className="p-[5px_10px] text-[12px] text-[#1B252F] rounded-[4px] border border-[#1B252F] bg-[#E9EAEB] flex items-center gap-[8px]">
            <img
              src="/images/usage_clr_ic.png"
              alt="icon"
              className="w-[15px]"
            />
            {name}
          </div>
        );
      // case "approvaltime":
      //   return (
      //     <div className="p-[5px_10px] text-[12px] text-[#27AE60] rounded-[4px] border border-[#27AE60] bg-[#DBFFDE] flex items-center gap-[8px]">
      //       <img
      //         src="/images/category_clr_ic.png"
      //         alt="icon"
      //         className="w-[15px]"
      //       />
      //       {name}
      //     </div>
      //   );
      // case "ltv":
      //   return (
      //     <div className="p-[5px_10px] text-[12px] text-[#27AE60] rounded-[4px] border border-[#27AE60] bg-[#DBFFDE] flex items-center gap-[8px]">
      //       <img
      //         src="/images/category_clr_ic.png"
      //         alt="icon"
      //         className="w-[15px]"
      //       />
      //       {name}
      //     </div>
      //   );
      default:
        return <></>;
    }
  };

  return Object.keys(selectedNotification)?.length > 0 ? (
    <div className="flex-[1] w-[600px] max-w-full">
      <div className="p-[17px_26px_0px_26px]">
        <h1 className="font-[600] text-[13px]">Loan Provider</h1>
      </div>
      <div className="flex flex-wrap gap-[20px] justify-between items-center p-[17px_26px] pt-[10px] border-b border-[#EAEAEA]">
        <div className="notf_card_box flex items-center gap-[10px]">
          <div className="min-[1181px]:hidden" onClick={() => props.notfBar(true)}>
            <MdOutlineNotificationsNone className={`text-[#0560FB] text-[20px]`} />
          </div>
          <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
            <img
              src={`https://api.ohhto.com/${selectedNotification?.icon}`}
              className="rounded-[8px]"
              width="58"
              height="58"
            />
          </div>
          <div>
            <h5 className="text-[13px] mb-[2px]">
              <b>{selectedNotification?.name}</b>
            </h5>
            <p className="text-black text-[13px]">
              {selectedNotification?.message}
            </p>
          </div>
        </div>
        <div className="flex gap-[50px] items-center">
          <div className="text-[#0D062D] text-[13px] font-[600]">
            {moment(selectedNotification?.loginfo?.updated_at)
              .format("DD MMM YYYY")
              .toUpperCase()}
            ,{" "}
            {moment(selectedNotification?.loginfo?.updated_at).format("HH:MM") +
              "   hrs"}
          </div>
        </div>
      </div>

      {selectedNotification?.updated_information?.map((notification, index) => (
        <>
          {notification?.loginfo?.changes?.interest_changes &&
            notification?.loginfo?.changes?.interest_changes[0]?.schedule !==
            undefined && (
              <div className="border-b border-[#EAEAEA]">
                <div className="p-[26px]">
                  <div className="flex items-center gap-[10px_40px] mb-[15px] max-[600px]:flex-col max-[600px]:items-start">
                    <div className="flex items-center gap-[13px]">
                      <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                        <img
                          src={`https://api.ohhto.com/${notification?.loginfo?.after_update?.product?.icon}`}
                          className="object-cover h-full w-full"
                        />
                      </div>
                      <h3 className="text-black text-[13px] font-[600]">
                        {notification?.loginfo?.after_update?.product?.name}
                      </h3>
                    </div>
                    <div className="p-[6px_20px] text-[#FD4954] text-[13px] font-[600] rounded-[4px] bg-[#FFECEC]">
                      Bank Rate Scheduled
                    </div>
                  </div>
                  <div className="flex items-center gap-[11px] flex-wrap">
                    {notification?.iteminfo?.displaytabs?.length > 0 &&
                      notification?.iteminfo?.displaytabs?.map((item) =>
                        GetCategory(item?.type, item?.name)
                      )}
                  </div>
                </div>
                <div className="pl-[27px]">
                  <Tabs
                    className="notficInterestTab"
                    items={[
                      {
                        key: "0",
                        label: "Low Tier",
                      },
                      {
                        key: "1",
                        label: "High Tier",
                      },
                    ]}
                    defaultActiveKey={activeTab}
                    onChange={(key) => {
                      setActiveTab({
                        ...activeTab,
                        [notification?.id]: Number(key),
                      });
                    }}
                  />
                </div>
                <div className="px-[27px] mt-[15px] mb-[30px] max-[600px]:px-0">
                  {notification?.loginfo?.after_update?.interests[
                    activeTab[notification?.id]
                  ]?.schedule !== null ? (
                    <>
                      <div className="p-[18px_23px] rounded-[10px] bg-[#edf1f5b8] border border-[#E3E3E3] mb-2 mb-[5px]">
                        <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                          <div className="mr-[35px]">
                            <div className="text-[#0560FB] text-[12px] font-[600] p-[6px] w-full rounded-[4px] bg-[#DDEAFF] text-center mb-[10px]">
                              Schedule
                            </div>
                            <div className="rounded-[6px] min-w-[116px] bg-white p-[6px] text-center">
                              <h3 className="text-[#787486] font-[500] text-[12px]">
                                Interest Rate
                              </h3>

                              <span className="inline-block text-[25px] font-[800] text-[#263238] flex justify-center">
                                <p>
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.schedule?.interest
                                  }
                                  %
                                </p>
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.map((it) => it?.schedule)
                                  ?.map((id) => id?.interest)
                                  ?.includes(
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.schedule?.interest
                                  ) && (
                                    <p className="text-[#e61034] text-[15px] font-[500]">
                                      *
                                    </p>
                                  )}
                              </span>
                            </div>
                          </div>
                          <div className="flex-[1]">
                            <div>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                {console.log("NOTIFOCATIONCHANGES", notification?.loginfo?.changes)}
                                Available from:
                                {notification?.loginfo?.after_update
                                  ?.interests[activeTab[notification?.id]]
                                  ?.schedule?.startDate !== undefined ? (
                                  <strong className="ml-[5px] font-[600] flex">
                                    {moment(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.schedule?.startDate
                                    )
                                      .format("DD MMM YYYY")
                                      .toUpperCase()}{" "}

                                    <span className="mx-[6px]">to</span>{" "}
                                    {notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.schedule?.endDate !== null
                                      ? moment(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.endDate
                                      )
                                        .format("DD MMM YYYY")
                                        .toUpperCase()
                                      : "Further Notice"}

                                    {notification?.loginfo?.changes
                                      ?.interest_changes?.length > 0 &&
                                      notification?.loginfo?.changes?.interest_changes
                                        ?.map((it) => it?.schedule)
                                        ?.map((id) => id?.endDate)
                                        ?.includes(
                                          notification?.loginfo?.after_update
                                            ?.interests[
                                            activeTab[notification?.id]
                                          ]?.schedule?.endDate
                                        ) ? (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                        *
                                      </p>
                                    ) : notification?.loginfo?.changes
                                      ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes?.interest_changes
                                      ?.map((it) => it?.schedule)
                                      ?.map((id) => id?.startDate)
                                      ?.includes(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.startDate
                                      ) && (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                        *
                                      </p>
                                    )}

                                  </strong>
                                ) : ("")}
                              </p>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center justify-between min-w-[257px] max-[600px]:flex-wrap max-[600px]:gap-[10px]">
                                <span className="flex items-center">
                                  <img
                                    src="/images/fi_calendar.svg"
                                    alt="calendar"
                                    className="mr-[5px]"
                                  />
                                  Min. Loan:
                                  {notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.schedule?.minimum_loan_amount !== 0 ? (
                                    <strong className="ml-[5px] font-[600] flex">
                                      ${" "}
                                      {
                                        notification?.loginfo?.after_update
                                          ?.interests[activeTab[notification?.id]]
                                          ?.schedule?.minimum_loan_amount
                                      }{" "}

                                      else<span className="mx-[6px]">+</span>admin
                                      fee ${" "}
                                      {
                                        notification?.loginfo?.after_update
                                          ?.interests[activeTab[notification?.id]]
                                          ?.schedule?.admin_fee
                                      }
                                      {notification?.loginfo?.changes
                                        ?.interest_changes?.length > 0 &&
                                        notification?.loginfo?.changes?.interest_changes
                                          ?.map((it) => it?.schedule)
                                          ?.map((id) => id?.admin_fee)
                                          ?.includes(
                                            notification?.loginfo?.after_update
                                              ?.interests[
                                              activeTab[notification?.id]
                                            ]?.schedule?.admin_fee
                                          ) ? (
                                        <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                          *
                                        </p>
                                      ) : (
                                        notification?.loginfo?.changes
                                          ?.interest_changes?.length > 0 &&
                                        notification?.loginfo?.changes?.interest_changes
                                          ?.map((it) => it?.schedule)
                                          ?.map((id) => id?.minimum_loan_amount)
                                          ?.includes(
                                            notification?.loginfo?.after_update
                                              ?.interests[
                                              activeTab[notification?.id]
                                            ]?.schedule?.minimum_loan_amount
                                          ) && (
                                          <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                            *
                                          </p>
                                        )

                                      )}
                                    </strong>
                                  ) : (
                                    <strong className="ml-[5px] font-[600]">
                                      No min. loan required{" "}
                                    </strong>
                                  )}
                                </span>
                                <span className="rounded-[6px] bg-white p-[6px] text-center ml-[10px] max-[600px]:ml-0">
                                  <span className="p-[6px_20px] text-[#FD4954] text-[13px] font-[600] rounded-[4px]">
                                    Bank Rate Changes
                                  </span>
                                </span>
                              </p>
                              <div>
                                <span className="text-[12px] mb-[3px] max-[600px]:mb-[5px] flex">
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.schedule?.remarks1
                                  }
                                  {notification?.loginfo?.changes
                                    ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes?.interest_changes
                                      ?.map((it) => it?.schedule)
                                      ?.map((id) => id?.remarks1)
                                      ?.includes(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.remarks1
                                      ) && (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500] ">
                                        *
                                      </p>
                                    )}
                                  <span className="text-[12px] ml-[auto] max-[600px]:mb-[5px] flex items-center float-right max-[600px]:float-none max-[600px]:mt-[10px]">
                                    <img
                                      src="/images/fi_calendar.svg"
                                      alt="calendar"
                                      className="mr-[5px]"
                                    />
                                    Changes On :
                                    <strong className="ml-[5px] font-[600] flex">
                                      {moment(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.scheduleDate
                                      )
                                        .format("DD MMM YYYY")
                                        .toUpperCase()}
                                      ,{" "}
                                      {moment(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.scheduleDate
                                      ).format("HH:MM") + "   hrs"}
                                    </strong>
                                  </span>
                                </span>
                                <span className="text-[12px] mb-[3px] max-[600px]:mb-[5px] flex">
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.schedule?.remarks2
                                  }
                                  {notification?.loginfo?.changes
                                    ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes
                                      ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes?.interest_changes
                                      ?.map((it) => it?.schedule)
                                      ?.map((id) => id?.remarks2)
                                      ?.includes(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.schedule?.remarks2
                                      ) && (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                        *
                                      </p>
                                    )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="p-[18px_23px] rounded-[10px] border border-[#E3E3E3] mb-[20px]">
                        <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                          <div className="mr-[35px]">
                            <div className="text-[#0560FB] text-[12px] font-[600] p-[6px] w-full rounded-[4px] border border-[#0560FB] text-center mb-[10px]">
                              Current
                            </div>
                            <div className="rounded-[6px] min-w-[116px] bg-[#EDF1F5] p-[6px] text-center">
                              <h3 className="text-[#787486] font-[500] text-[12px]">
                                Interest Rate
                              </h3>
                              {console.log("SCHEDULECURRENT", notification?.loginfo)}

                              <span className="inline-block text-[25px] font-[800] text-[#263238]">
                                {
                                  notification?.loginfo?.after_update

                                    ?.interests[activeTab[notification?.id]]?.interest
                                }
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.map((id) => id?.interest)
                                  ?.includes(
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]?.interest
                                  )
                                  ? "%"
                                  : "%"}
                              </span>

                            </div>
                          </div>
                          <div className="flex-[1]">
                            <div>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                Available from:
                                {notification?.loginfo?.after_update
                                  ?.interests[activeTab[notification?.id]]
                                  ?.startDate !== undefined ? (
                                  <strong className="ml-[5px] font-[600]">
                                    {moment(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.startDate
                                    )
                                      .format("DD MMM YYYY")
                                      .toUpperCase()}{" "}
                                    <span className="mx-[6px]">to</span>{" "}
                                    {notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.endDate !== null
                                      ? moment(
                                        notification?.loginfo?.after_update
                                          ?.interests[
                                          activeTab[notification?.id]
                                        ]?.endDate
                                      )
                                        .format("DD MMM YYYY")
                                        .toUpperCase()
                                      : "Further Notice"}
                                  </strong>
                                ) : ("")}
                              </p>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                Min. Loan:
                                {notification?.loginfo?.after_update
                                  ?.interests[activeTab[notification?.id]]
                                  ?.minimum_loan_amount !== 0 ? (
                                  <strong className="ml-[5px] font-[600]">
                                    $
                                    {
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.minimum_loan_amount
                                    }{" "}
                                    else<span className="mx-[6px]">+</span>admin
                                    fee $
                                    {
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.admin_fee
                                    }
                                  </strong>
                                ) : (
                                  <strong className="ml-[5px] font-[600]">
                                    No min. loan required{" "}
                                  </strong>
                                )}
                              </p>
                              <div>
                                <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.remarks1
                                  }
                                </p>
                                <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.remarks2
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="p-[18px_23px] rounded-[10px] bg-[#edf1f5b8] border border-[#E3E3E3] mb-2 mb-[5px]">
                      <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                        No Schedule Data found...!
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

          {notification?.is_created === 1 &&
            notification?.notification_type === "agent_commision" ? (
            <div className="border-b border-[#EAEAEA]">
              <div className="p-[26px]">
                <div className="flex items-center gap-[10px_40px] mb-[15px]">
                  <div className="flex items-center gap-[13px]">
                    <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                      <img
                        src={`https://api.ohhto.com/${notification?.iteminfo?.icon}`}
                        className="object-cover h-full w-full"
                      />
                    </div>
                    <h3 className="text-black text-[13px] font-[600]">
                      {notification?.iteminfo?.name}
                    </h3>
                  </div>
                  <div className="p-[6px_20px] text-[#27AE60] text-[13px] font-[600] rounded-[4px] bg-[#DBFFDE]">
                    Newly Added
                  </div>
                </div>
                <div className="flex items-center gap-[11px] flex-wrap">
                  {notification?.iteminfo?.displaytabs?.length > 0 &&
                    notification?.iteminfo?.displaytabs?.map((item) =>
                      GetCategory(item?.type, item?.name)
                    )}
                </div>
              </div>
              {/* <div className="pl-[27px]">
                <Tabs
                  className="notficInterestTab"
                  items={[
                    {
                      key: "0",
                      label: "Low Tier",
                    },
                    {
                      key: "1",
                      label: "High Tier",
                    },
                  ]}
                  defaultActiveKey="0"
                  onChange={(key) => {
                    setActiveTab({
                      ...activeTab,
                      [notification?.id]: Number(key),
                    });
                  }}
                />
              </div> */}
              <div className="px-[27px] mt-[40px] max-[600px]:px-[0px]">
                <div className="border border-[#DEDEDE] mb-[40px]">
                  <div className="p-[18px_23px] bg-[#F9FBFD] border-b border-[#DEDEDE]">
                    <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                      {/* <div className="mr-[35px] rounded-[6px] min-w-[100px] bg-white p-[12px] pb-[6px]">
                        <span className="inline-block text-[25px] font-[800] text-[#263238]">
                          {
                            notification?.iteminfo?.interests[
                              activeTab[notification?.id]
                            ]?.interest
                          }
                          %
                        </span>
                      </div> */}
                      <div className="rounded-[6px] min-w-[116px] bg-white p-[12px] pb-[6px] text-center">
                        <h3 className="text-[#787486] font-[500] text-[12px]">
                          {notification.iteminfo?.agentCommision !==
                            undefined &&
                            notification.iteminfo?.agentCommision?.is_ht === 1
                            ? "High Tier"
                            : notification.iteminfo?.agentCommision?.is_lt === 1
                              ? "Low Tier"
                              : "Interest Rate"}
                        </h3>
                        <span className="inline-block text-[25px] font-[800] text-[#263238]">
                          {
                            notification?.iteminfo?.agentCommision?.interestinfo
                              ?.interest
                          }
                          %
                        </span>
                      </div>
                      <div className="flex-[1]">
                        <div>
                          <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                            <img
                              src="/images/fi_calendar.svg"
                              alt="calendar"
                              className="mr-[5px]"
                            />
                            Available from:
                            <strong className="ml-[5px] font-[600]">
                              {moment(
                                notification?.iteminfo?.agentCommision
                                  ?.interestinfo?.startDate
                              )
                                .format("DD MMM YYYY")
                                .toUpperCase()}{" "}
                              { }
                              <span className="mx-[6px]">to</span>{" "}
                              {notification?.iteminfo?.agentCommision
                                ?.interestinfo?.endDate !== null
                                ? moment(
                                  notification?.iteminfo?.interests[
                                    activeTab[notification?.id]
                                  ]?.endDate
                                )
                                  .format("DD MMM YYYY")
                                  .toUpperCase()
                                : "Further Notice"}
                            </strong>
                          </p>
                          <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                            <img
                              src="/images/fi_calendar.svg"
                              alt="calendar"
                              className="mr-[5px]"
                            />
                            Min. Loan:
                            {notification?.iteminfo?.agentCommision
                              ?.interestinfo?.minimum_loan_amount !== 0 ? (
                              <strong className="ml-[5px] font-[600]">
                                $
                                {notification?.iteminfo?.agentCommision?.interestinfo?.minimum_loan_amount.toFixed(
                                  2
                                )}{" "}
                                else<span className="mx-[6px]">+</span>
                                admin fee $
                                {
                                  notification?.iteminfo?.agentCommision
                                    ?.interestinfo?.admin_fee
                                }
                              </strong>
                            ) : (
                              <strong className="ml-[5px] font-[600]">
                                No min. loan required{" "}
                              </strong>
                            )}
                            {/**No min. loan required */}
                          </p>
                          <div>
                            <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                              {
                                notification?.iteminfo?.agentCommision
                                  ?.interestinfo?.remarks1
                              }
                            </p>
                            <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                              {
                                notification?.iteminfo?.agentCommision
                                  ?.interestinfo?.remarks2
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {notification?.iteminfo?.agentCommision !== null && (
                    <div className="p-[24px_30px_24px_30px] singleLoanTab">
                      <div className="flex flex-wrap items-center mt-[10px] gap-[0px_10px] cus_date_pick mb-[27px]">
                        <label className="flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]">
                          Publish Date
                          <img
                            src="/images/fi_info.svg"
                            alt="info"
                            className="inline-block ml-[8px]"
                          />
                        </label>
                        <div className="text-[13px] font-[500]">
                          {moment(
                            notification?.iteminfo?.agentCommision?.startDate
                          ).format("DD-MM-YYYY")}
                        </div>
                        <span className="mx-[10px] text-[13px]">
                          To
                        </span>
                        <div className="text-[13px] font-[500]">
                          {" "}
                          {notification?.iteminfo?.agentCommision?.endDate !==
                            null
                            ? moment(
                              notification?.iteminfo?.agentCommision.endDate
                            ).format("DD-MM-YYYY")
                            : "Further Notice"}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px]">
                          Dealer Commission Rates
                        </label>
                        <div className="flex mt-[16px] gap-[8px] relative">
                          <div className="stick_header w-[115px] flex-shrink-0">
                            <p className="text-[13px] font-[500] text-[#495159] mb-[17px]">
                              Tenor (Years)
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] mb-[20px]">
                              Availability
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] flex items-center">
                              Commission
                            </p>
                          </div>
                          <div className="flex scBarHidden w-[950px] overflow-x-scroll gap-[25px]">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
                              return (
                                <div
                                  className="text-center dealer_com w-[95px]"
                                  key={it}
                                >
                                  <p className="text-[#495159] mb-[12px] text-[13px] font-[500]">
                                    {it}
                                  </p>
                                  <Popconfirm
                                    title="Want to edit this?"
                                    okText="Edit"
                                    cancelText="Cancel"
                                    icon={
                                      <BorderColorOutlined
                                        className="mr-[10px]"
                                        fontSize={"small"}
                                        htmlColor="#59758a"
                                      />
                                    }
                                    disabled
                                  >
                                    <div
                                      className={`custom_switch cursor-pointer`}
                                      style={{
                                        background:
                                          notification?.iteminfo
                                            ?.agentCommision[
                                            `year${it}_status`
                                          ] === 1
                                            ? ""
                                            : "#afb3b9",
                                      }}
                                    >
                                      <span className="sw_text">
                                        {notification?.iteminfo?.agentCommision[
                                          `year${it}_status`
                                        ] === 1
                                          ? "AVL"
                                          : "AVL"}
                                      </span>
                                      {notification?.iteminfo?.agentCommision[
                                        `year${it}_status`
                                      ] === 1 ? (
                                        <span className="thumb"></span>
                                      ) : (
                                        <span
                                          className="thumb"
                                          style={{
                                            transform: "translateX(-47px)",
                                          }}
                                        ></span>
                                      )}
                                    </div>
                                  </Popconfirm>
                                  <p className="mt-[15px] text-[#263238] text-[13px] font-[500]">
                                    {notification?.iteminfo?.agentCommision[
                                      `year${it}_status`
                                    ] === 1
                                      ? notification?.iteminfo?.agentCommision[
                                      `year${it}_fee`
                                      ]
                                      : "NA"}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px]">
                          Admin Fee
                        </label>
                        <div className="flex flex-wrap gap-[15px]">
                          {notification?.iteminfo?.agentCommision?.adminfees
                            ?.length > 0 ? (
                            notification?.iteminfo?.agentCommision?.adminfees?.map(
                              (feeItem, index) => (
                                <div className="p-[10px_13px] rounded-[8px] border border-[#E0E0E0] bg-[#F4F4F4]">
                                  <div className="mb-[2px]">
                                    <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                      Fee amount {index + 1}
                                    </span>
                                    <span className="text-[#263238] font-[500] text-[13px]">
                                      ${feeItem?.admin_fee}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                      Loan amount
                                    </span>
                                    <span className="text-[#263238] font-[500] text-[13px]">
                                      $ {feeItem?.minimum_loan_amount}
                                      <span className="mx-[10px]">to</span>$
                                      {feeItem?.maximum_loan_amount}
                                    </span>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="flex flex-wrap gap-[20px_12px] mb-2">
                              <h5>No Admin Fees found...!</h5>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px]">
                          Incentive
                        </label>

                        <p className="text-[#1B252F] text-[13px] font-[500] break-words">
                          {
                            notification?.iteminfo?.agentCommision
                              ?.incentive_amount
                          }
                          {notification?.iteminfo?.agentCommision
                            ?.incentive_type === 0
                            ? "%"
                            : "$"}
                        </p>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px]">
                          Remarks
                        </label>

                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => (
                          <p className="text-[#1B252F] text-[13px] font-[500] break-words	">
                            {
                              notification?.iteminfo?.agentCommision[
                              `remarks${it}`
                              ]
                            }
                          </p>
                        ))}
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px]">
                          Dealer Bonus
                        </label>
                        <div className="flex flex-wrap gap-[20px_12px] mb-2">
                          {notification?.iteminfo?.agentCommision?.agentbonuses
                            ?.length > 0 ? (
                            notification?.iteminfo?.agentCommision?.agentbonuses?.map(
                              (bonus) => (
                                // <div className="w-full max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
                                //   <div className="bg-[#0E085C] text-white flex flex-col items-center justify-center relative w-[140px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
                                //     <div className="absolute top-[8px] left-[8px]">
                                //       <img src="/images/fi_info_wh.svg" />
                                //     </div>
                                //     <h3 className="font-[800] text-[20px] leading-[25px] tracking-[-1px]">
                                //       {bonus?.bonusinfo?.bonus}%
                                //     </h3>
                                //     <span className="text-[10px] font-[400]">
                                //       Bonus Amount
                                //     </span>
                                //   </div>
                                //   <div className="p-[17px_27px_3px_27px] flex-[1]">
                                //     <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">
                                //       {bonus?.bonusinfo?.name}
                                //     </h3>
                                //     <div className="flex flex-wrap items-center justify-between gap-[15px_30px] mb-[14px]">
                                //       <div>
                                //         <label className="text-[#787486] text-[13px] block mb-[5px]">
                                //           Bonus Program Valid Period
                                //         </label>
                                //         <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
                                //           <img
                                //             src="/images/fi_calendar.svg"
                                //             className="mr-[5px]"
                                //           />
                                //           {moment(bonus?.bonusinfo?.startDate)
                                //             .format("DD MMM YYYY")
                                //             .toUpperCase()}
                                //           <span className="mx-[7px]">to</span>
                                //           {moment(bonus?.bonusinfo?.endDate)
                                //             .format("DD MMM YYYY")
                                //             .toUpperCase()}
                                //         </p>
                                //       </div>
                                //       <div className="min-w-[230px] max-w-full">
                                //         <label className="text-[#787486] text-[13px] block mb-[5px]">
                                //           Qualifying loan amount
                                //         </label>
                                //         <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                                //           $
                                //           {
                                //             bonus?.bonusinfo
                                //               ?.minimum_loan_amount
                                //           }
                                //           <span className="mx-[7px]">to</span>$
                                //           {
                                //             bonus?.bonusinfo
                                //               ?.maximum_loan_amount
                                //           }
                                //         </p>
                                //       </div>
                                //       <div>
                                //         <label className="text-[#787486] text-[13px] block mb-[5px]">
                                //           Qualifying period & Payout
                                //         </label>
                                //         <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                                //           Calendar Week payout within{" "}
                                //           {bonus?.bonusinfo?.payout_days} days
                                //           after end of qualifying period
                                //         </p>
                                //       </div>
                                //     </div>
                                //   </div>
                                // </div>
                                <BonusCard bonus={bonus?.bonusinfo} />
                              )
                            )
                          ) : (
                            <div className="flex flex-wrap gap-[20px_12px] mb-2">
                              <h5>No Dealer Bonus found...!</h5>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            notification?.is_updated === 0 && (
              <div className="border-b border-[#EAEAEA]">
                <div className="p-[26px]">
                  <div className="flex items-center gap-[10px_40px] mb-[15px]">
                    <div className="flex items-center gap-[13px]">
                      <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                        <img
                          src={`https://api.ohhto.com/${notification?.iteminfo?.icon}`}
                          className="object-cover h-full w-full"
                        />
                      </div>
                      <h3 className="text-black text-[13px] font-[600]">
                        {notification?.iteminfo?.name}
                      </h3>
                    </div>
                    <div className="p-[6px_20px] text-[#27AE60] text-[13px] font-[600] rounded-[4px] bg-[#DBFFDE]">
                      Newly Added
                    </div>
                  </div>
                  <div className="flex items-center gap-[11px] flex-wrap">
                    {notification?.iteminfo?.displaytabs?.length > 0 &&
                      notification?.iteminfo?.displaytabs?.map((item) =>
                        GetCategory(item?.type, item?.name)
                      )}
                  </div>
                </div>
                <div className="pl-[27px]">
                  <Tabs
                    className="notficInterestTab"
                    items={[
                      {
                        key: "0",
                        label: "Low Tier",
                      },
                      {
                        key: "1",
                        label: "High Tier",
                      },
                    ]}
                    defaultActiveKey="0"
                    onChange={(key) => {
                      setActiveTab({
                        ...activeTab,
                        [notification?.id]: Number(key),
                      });
                    }}
                  />
                </div>
                <div className="px-[27px] mt-[40px] max-[600px]:px-[0px]">
                  {notification?.iteminfo?.interests[
                    activeTab[notification?.id]
                  ] !== undefined ? (
                    <div className="border border-[#DEDEDE] mb-[40px]">
                      <div className="p-[18px_23px] bg-[#F9FBFD] border-b border-[#DEDEDE]">
                        <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                          <div className="rounded-[6px] min-w-[116px] bg-white p-[12px] pb-[6px]">
                            <h3 className="text-[#787486] font-[500] text-[12px]">
                              Interest Rate
                            </h3>
                            <span className="inline-block text-[25px] font-[800] text-[#263238]">
                              {
                                notification?.iteminfo?.interests[
                                  activeTab[notification?.id]
                                ]?.interest
                              }
                              %
                            </span>
                          </div>
                          <div className="flex-[1]">
                            <div>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                Available from:
                                <strong className="ml-[5px] font-[600]">
                                  {moment(
                                    notification?.iteminfo?.interests[
                                      activeTab[notification?.id]
                                    ]?.startDate
                                  )
                                    .format("DD MMM YYYY")
                                    .toUpperCase()}{" "}
                                  { }
                                  <span className="mx-[6px]">to</span>{" "}
                                  {notification?.iteminfo?.interests[
                                    activeTab[notification?.id]
                                  ]?.endDate !== null
                                    ? moment(
                                      notification?.iteminfo?.interests[
                                        activeTab[notification?.id]
                                      ]?.endDate
                                    )
                                      .format("DD MMM YYYY")
                                      .toUpperCase()
                                    : "Further Notice"}
                                </strong>
                              </p>
                              <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                Min. Loan:
                                {notification?.iteminfo?.interests[
                                  activeTab[notification?.id]
                                ]?.minimum_loan_amount !== 0 ? (
                                  <strong className="ml-[5px] font-[600]">
                                    $
                                    {notification?.iteminfo?.interests[
                                      activeTab[notification?.id]
                                    ]?.minimum_loan_amount.toFixed(2)}{" "}
                                    else<span className="mx-[6px]">+</span>
                                    admin fee $
                                    {
                                      notification?.iteminfo?.interests[
                                        activeTab[notification?.id]
                                      ]?.admin_fee
                                    }
                                  </strong>
                                ) : (
                                  <strong className="ml-[5px] font-[600]">
                                    No min. loan required{" "}
                                  </strong>
                                )}
                              </p>
                              <div>
                                <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                  {
                                    notification?.iteminfo?.interests[
                                      activeTab[notification?.id]
                                    ]?.remarks1
                                  }
                                </p>
                                <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                  {
                                    notification?.iteminfo?.interests[
                                      activeTab[notification?.id]
                                    ]?.remarks2
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (<div className="p-[18px_23px] rounded-[10px] bg-[#edf1f5b8] border border-[#E3E3E3] mb-2 mb-[5px]">
                    <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                      No {activeTab[notification?.id] == 0 ? "Low" : "High"} tier data Found..!
                    </div>
                  </div>)}
                </div>
              </div>
            )
          )}

          {notification?.loginfo?.changes?.interest_changes &&
            notification?.loginfo?.changes?.interest_changes[0]?.schedule ===
            undefined && (
              <div className="border-b border-[#EAEAEA]">
                <div className="p-[26px]">
                  <div className="flex items-center gap-[10px_40px] mb-[15px]">
                    <div className="flex items-center gap-[13px]">
                      <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                        <img
                          src={`https://api.ohhto.com/${notification?.loginfo?.after_update?.product?.icon}`}
                          className="rounded-[8px]"
                          width="58"
                          height="58"
                        />
                      </div>
                      <h3 className="text-black text-[13px] font-[600]">
                        {notification?.loginfo?.after_update?.product?.name}
                      </h3>
                    </div>
                    <div className="p-[6px_20px] text-[#0560FB] text-[13px] font-[600] rounded-[4px] bg-[#DDEAFF]">
                      Interest Rate Changes
                    </div>
                  </div>
                  <div className="flex items-center gap-[11px] flex-wrap">
                    {notification?.iteminfo?.displaytabs?.length > 0 &&
                      notification?.iteminfo?.displaytabs?.map((item) =>
                        GetCategory(item?.type, item?.name)
                      )}
                  </div>
                </div>
                <div className="pl-[27px]">
                  <Tabs
                    className="notficInterestTab"
                    items={[
                      {
                        key: "0",
                        label: "Low Tier",
                      },
                      {
                        key: "1",
                        label: "High Tier",
                      },
                    ]}
                    defaultActiveKey={activeTab}
                    onChange={(key) => {
                      setActiveTab({
                        ...activeTab,
                        [notification?.id]: Number(key),
                      });
                    }}
                  />
                </div>
                {notification?.loginfo?.before_update?.interests[activeTab[notification?.id]] !== undefined ? (
                  <div className="px-[27px] mt-[15px] mb-[30px]">

                    <div className="p-[18px_23px] rounded-[10px] bg-[#edf1f5b8] border border-[#E3E3E3] mb-2">
                      <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                        <div className="mr-[35px]">
                          <div className="text-[#0560FB] text-[12px] font-[600] p-[6px] w-full rounded-[4px] bg-[#DDEAFF] text-center mb-[10px]">
                            After
                          </div>
                          <div className="rounded-[6px] min-w-[116px] bg-white p-[12px] pb-[6px] text-center">
                            <h3 className="text-[#787486] font-[500] text-[12px]">
                              Interest Rate
                            </h3>
                            <span className="inline-block text-[25px] font-[800] text-[#263238] flex justify-center">
                              <p>
                                {
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.interest
                                }
                                %
                              </p>
                              {notification?.loginfo?.changes?.interest_changes
                                ?.length > 0 &&
                                notification?.loginfo?.changes?.interest_changes
                                  ?.map((it) => it?.interest)
                                  ?.includes(
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.interest
                                  ) && (
                                  <p className="text-[#e61034] text-[15px] font-[500]">
                                    *
                                  </p>
                                )}
                            </span>
                          </div>
                        </div>
                        <div className="flex-[1]">
                          <div>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Available from:
                              <strong className="ml-[5px] font-[600] flex">
                                {moment(
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.startDate
                                )
                                  .format("DD MMM YYYY")
                                  .toUpperCase()}{" "}
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.length > 0 &&
                                  notification?.loginfo?.changes?.interest_changes
                                    ?.map((it) => it?.startDate)
                                    ?.includes(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.startDate
                                    ) && (
                                    <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                      *
                                    </p>
                                  )}
                                <span className="mx-[6px]">to</span>{" "}
                                {notification?.loginfo?.after_update?.interests[
                                  activeTab[notification?.id]
                                ]?.endDate !== null
                                  ? moment(
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.endDate
                                  )
                                    .format("DD MMM YYYY")
                                    .toUpperCase()
                                  : "Further Notice"}
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.length > 0 &&
                                  notification?.loginfo?.changes?.interest_changes
                                    ?.map((it) => it?.endDate)
                                    ?.includes(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.endDate
                                    ) && (
                                    <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                      *
                                    </p>
                                  )}
                              </strong>
                            </p>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Min. Loan:
                              {notification?.loginfo?.after_update?.interests[
                                activeTab[notification?.id]
                              ]?.minimum_loan_amount !== 0 ? (
                                <strong className="ml-[5px] font-[600] flex">
                                  ${" "}
                                  {notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.minimum_loan_amount.toFixed(2)}{" "}
                                  {notification?.loginfo?.changes
                                    ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes?.interest_changes
                                      ?.map((it) => it?.minimum_loan_amount)
                                      ?.includes(
                                        notification?.loginfo?.after_update
                                          ?.interests[activeTab[notification?.id]]
                                          ?.minimum_loan_amount
                                      ) && (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                        *
                                      </p>
                                    )}
                                  else<span className="mx-[6px]">+</span>admin fee
                                  ${" "}
                                  {
                                    notification?.loginfo?.after_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.admin_fee
                                  }
                                  {notification?.loginfo?.changes
                                    ?.interest_changes?.length > 0 &&
                                    notification?.loginfo?.changes?.interest_changes
                                      ?.map((it) => it?.admin_fee)
                                      ?.includes(
                                        notification?.loginfo?.after_update
                                          ?.interests[activeTab[notification?.id]]
                                          ?.admin_fee
                                      ) && (
                                      <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                        *
                                      </p>
                                    )}
                                </strong>
                              ) : (
                                <strong className="ml-[5px] font-[600]">
                                  No min. loan required{" "}
                                </strong>
                              )}
                            </p>
                            <div>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px] flex">
                                {
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.remarks1
                                }
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.length > 0 &&
                                  notification?.loginfo?.changes?.interest_changes
                                    ?.map((it) => it?.remarks1)
                                    ?.includes(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.remarks1
                                    ) && (
                                    <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                      *
                                    </p>
                                  )}
                              </p>

                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px] flex">
                                {
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.remarks2
                                }
                                {notification?.loginfo?.changes?.interest_changes
                                  ?.length > 0 &&
                                  notification?.loginfo?.changes?.interest_changes
                                    ?.map((it) => it?.remarks2)
                                    ?.includes(
                                      notification?.loginfo?.after_update
                                        ?.interests[activeTab[notification?.id]]
                                        ?.remarks2
                                    ) && (
                                    <p className="text-[#e61034] ml-[5px] text-[15px] font-[500]">
                                      *
                                    </p>
                                  )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-[18px_23px] rounded-[10px] border border-[#E3E3E3] mb-[20px]">
                      <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                        <div className="mr-[35px]">
                          <div className="text-[#0560FB] text-[12px] font-[600] p-[6px] w-full rounded-[4px] border border-[#0560FB] text-center mb-[10px]">
                            Before
                          </div>
                          <div className="rounded-[6px] min-w-[116px] bg-[#EDF1F5] p-[12px] pb-[6px] text-center">
                            <h3 className="text-[#787486] font-[500] text-[12px]">
                              Interest Rate
                            </h3>
                            <span className="inline-block text-[25px] font-[800] text-[#263238]">
                              {
                                notification?.loginfo?.before_update?.interests[
                                  activeTab[notification?.id]
                                ]?.interest
                              }
                              {notification?.loginfo?.changes?.interest_changes
                                ?.map((it) => it?.interest)
                                ?.includes(
                                  notification?.loginfo?.before_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.interest
                                )
                                ? "%"
                                : "%"}
                            </span>
                          </div>
                        </div>
                        <div className="flex-[1]">
                          <div>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Available from:
                              <strong className="ml-[5px] font-[600]">
                                {moment(
                                  notification?.loginfo?.before_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.startDate
                                )
                                  .format("DD MMM YYYY")
                                  .toUpperCase()}{" "}
                                <span className="mx-[6px]">to</span>{" "}
                                {notification?.loginfo?.before_update?.interests[
                                  activeTab[notification?.id]
                                ]?.endDate !== null
                                  ? moment(
                                    notification?.loginfo?.before_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.startDate
                                  )
                                    .format("DD MMM YYYY")
                                    .toUpperCase()
                                  : "Further Notice"}
                              </strong>
                            </p>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Min. Loan:
                              {notification?.loginfo?.before_update?.interests[
                                activeTab[notification?.id]
                              ]?.minimum_loan_amount !== 0 ? (
                                <strong className="ml-[5px] font-[600]">
                                  $
                                  {notification?.loginfo?.before_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.minimum_loan_amount.toFixed(2)}{" "}
                                  else<span className="mx-[6px]">+</span>admin fee
                                  $
                                  {
                                    notification?.loginfo?.before_update
                                      ?.interests[activeTab[notification?.id]]
                                      ?.admin_fee
                                  }
                                </strong>
                              ) : (
                                <strong className="ml-[5px] font-[600]">
                                  No min. loan required{" "}
                                </strong>
                              )}
                            </p>
                            <div>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                {
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.remarks1
                                }
                              </p>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                {
                                  notification?.loginfo?.after_update?.interests[
                                    activeTab[notification?.id]
                                  ]?.remarks2
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (<div className="p-[18px_23px] rounded-[10px] bg-[#edf1f5b8] border border-[#E3E3E3] mb-2 mb-[5px]">
                  <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                    No {activeTab[notification?.id] == 0 ? "Low" : "High"} tier data Found..!
                  </div>
                </div>)}
              </div>
            )}

          {notification?.is_updated === 1 &&
            notification?.notification_type === "agent_commision" &&
            notification.loginfo?.changes?.schedule !== undefined && (
              <div className="border-b border-[#EAEAEA]">
                <div className="p-[26px]">
                  <div className="flex items-center gap-[10px_40px] mb-[15px]">
                    <div className="flex items-center gap-[13px]">
                      <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                        <img
                          src={`https://api.ohhto.com/${notification?.iteminfo?.icon}`}
                          className="object-cover h-full w-full"
                        />
                      </div>
                      <h3 className="text-black text-[13px] font-[600]">
                        {notification?.iteminfo?.name}
                      </h3>
                    </div>
                    <div className="p-[6px_20px] text-[#FD4954] text-[13px] font-[600] rounded-[4px] bg-[#FFECEC]">
                      Dealer Comm. Schedule Changes
                    </div>
                  </div>
                  <div className="flex items-center gap-[11px] flex-wrap">
                    {notification?.iteminfo?.displaytabs?.length > 0 &&
                      notification?.iteminfo?.displaytabs?.map((item) =>
                        GetCategory(item?.type, item?.name)
                      )}
                  </div>
                </div>
                <div className="pl-[27px]">
                  {/* <Tabs
                    className="notficInterestTab"
                    items={[
                      {
                        key: "0",
                        label: "Low Tier",
                      },
                      {
                        key: "1",
                        label: "High Tier",
                      },
                    ]}
                    defaultActiveKey="0"
                    onChange={(key) => {
                      setActiveTab({
                        ...activeTab,
                        [notification?.id]: Number(key),
                      });
                    }}
                  /> */}
                </div>

                <div className="px-[27px] mt-[40px] max-[600px]:px-[0px]">
                  {/* {notification?.iteminfo?.interests[
                    activeTab[notification?.id]
                  ]?.agentbonusinfo !== null &&
                    notification?.iteminfo?.interests[
                      activeTab[notification?.id]
                    ]?.agentbonusinfo?.id === notification?.loginfo?.item && (                    )} */}

                  <Segmented
                    className="intTabSeg"
                    options={[
                      { label: "Schedule", value: "after_update" },
                      { label: "Current", value: "before_update" },
                    ]}
                    onChange={(value) => {
                      setCommissionSegment({
                        ...commissionSegment,
                        [notification?.id]: value,
                      });
                    }}
                  />
                  <div className="border border-[#DEDEDE] mb-[40px]">
                    <div className="p-[18px_23px] bg-[#edf1f5b8] border-b border-[#DEDEDE]">
                      <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px] relative">
                        {/* <div className="mr-[35px] rounded-[6px] min-w-[100px] bg-white p-[12px] pb-[6px]">
                          <span className="inline-block text-[25px] font-[800] text-[#263238]">
                            {
                              notification?.iteminfo?.interests[
                                activeTab[notification?.id]
                              ]?.interest
                            }
                            %
                          </span>
                        </div> */}
                        {console.log("SCHEDULE", notification)}
                        <div className="rounded-[6px] min-w-[116px] bg-white p-[12px] pb-[6px] text-center mr-[10px]">
                          <h3 className="text-[#787486] font-[500] text-[12px]">
                            {notification.iteminfo?.agentCommision !==
                              undefined &&
                              notification.iteminfo?.agentCommision?.is_ht === 1
                              ? "High Tier"
                              : notification.iteminfo?.agentCommision?.is_lt ===
                                1
                                ? "Low Tier"
                                : "Interest Rate"}
                          </h3>
                          <span className="inline-block text-[25px] font-[800] text-[#263238]">
                            {
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.schedule?.commision_info?.interestinfo
                                ?.interest
                            }
                            %
                          </span>
                        </div>
                        <div className="flex-[1]">
                          <div>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Available from:
                              <strong className="ml-[5px] font-[600]">
                                {moment(
                                  notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.schedule?.commision_info?.interestinfo
                                    ?.startDate
                                )
                                  .format("DD MMM YYYY")
                                  .toUpperCase()}{" "}
                                { }
                                <span className="mx-[6px]">to</span>{" "}
                                {notification?.loginfo[
                                  commissionSegment[notification?.id]
                                ]?.schedule?.commision_info?.interestinfo
                                  ?.endDate !== null
                                  ? moment(
                                    notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.schedule?.commision_info?.interestinfo
                                      ?.endDate
                                  )
                                    .format("DD MMM YYYY")
                                    .toUpperCase()
                                  : "Further Notice"}
                              </strong>
                            </p>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center justify-between min-w-[257px]">
                              <span className="flex items-center">
                                <img
                                  src="/images/fi_calendar.svg"
                                  alt="calendar"
                                  className="mr-[5px]"
                                />
                                Min. Loan:
                                {notification?.loginfo[
                                  commissionSegment[notification?.id]
                                ]?.schedule?.commision_info?.interestinfo
                                  ?.minimum_loan_amount !== 0 ? (
                                  <strong className="ml-[5px] font-[600]">
                                    $
                                    {notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.schedule?.commision_info?.interestinfo?.minimum_loan_amount.toFixed(
                                      2
                                    )}{" "}
                                    else<span className="mx-[6px]">+</span>
                                    admin fee $
                                    {
                                      notification?.loginfo[
                                        commissionSegment[notification?.id]
                                      ]?.schedule?.commision_info?.interestinfo
                                        ?.admin_fee
                                    }
                                  </strong>
                                ) : (
                                  <strong className="ml-[5px] font-[600]">
                                    No min. loan required{" "}
                                  </strong>
                                )}
                              </span>
                              {console.log(
                                "SEGMEMNT",
                                commissionSegment[notification?.id] ===
                                "after_update"
                              )}
                              {commissionSegment[notification?.id] ===
                                "after_update" && (
                                  <span className="rounded-[6px] bg-white p-[6px] text-center ml-[10px] absolute top-0 right-0">
                                    <span className="p-[6px_20px] text-[#FD4954] text-[13px] font-[600] rounded-[4px]">
                                      Bank Rate Changes
                                    </span>
                                  </span>
                                )}
                            </p>

                            <div>
                              <div className="flex justify-between items-center">
                                <p className="text-[12px] mt-[5px] max-[600px]:mb-[5px]">
                                  {
                                    notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.schedule?.commision_info?.interestinfo
                                      ?.remarks1
                                  }
                                </p>
                                {commissionSegment[notification?.id] ===
                                  "after_update" && (
                                    <p className="text-[12px] max-[600px]:mb-[5px] flex items-center min-w-[257px] ml-[20 0px] ">
                                      <img
                                        src="/images/fi_calendar.svg"
                                        alt="calendar"
                                        className="mr-[5px]"
                                      />
                                      Changes On :
                                      <strong className="ml-[5px] font-[600] flex">
                                        {moment(
                                          notification?.loginfo[
                                            commissionSegment[notification?.id]
                                          ]?.schedule?.commision_info
                                            ?.interestinfo?.scheduleDate
                                        )
                                          .format("DD MMM YYYY")
                                          .toUpperCase()}
                                        ,{" "}
                                        {moment(
                                          notification?.loginfo[
                                            commissionSegment[notification?.id]
                                          ]?.schedule?.commision_info
                                            ?.interestinfo?.scheduleDate
                                        ).format("HH:MM") + "   hrs"}
                                      </strong>
                                    </p>
                                  )}
                              </div>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                {
                                  notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.schedule?.commision_info?.interestinfo
                                    ?.remarks2
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="p-[24px_30px_24px_30px] singleLoanTab">
                      <div className="flex flex-wrap items-center mt-[10px] gap-[0px_10px] cus_date_pick mb-[27px]">
                        <label className="flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]">
                          Publish Date
                          <img
                            src="/images/fi_info.svg"
                            alt="info"
                            className="inline-block ml-[8px]"
                          />
                        </label>
                        <div className="text-[13px] font-[500] flex">
                          {moment(
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.schedule?.commision_info?.startDate
                          ).format("DD-MM-YYYY")}
                          {notification?.loginfo?.changes?.startDate ===
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.schedule?.commision_info?.startDate && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </div>
                        <span className="mx-[10px] text-[13px]">
                          To
                        </span>
                        <div className="text-[13px] font-[500] flex">
                          {" "}
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.schedule?.commision_info?.endDate
                            ? moment(
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.schedule?.commision_info?.endDate
                            ).format("DD-MM-YYYY")
                            : "Further Notice"}
                          {notification?.loginfo?.changes?.endDate ===
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.schedule?.commision_info?.endDate && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Dealer Commission Rates
                          {notification?.loginfo?.changes?.
                            commision_info !== undefined && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        <div className="flex mt-[16px] gap-[8px] relative">
                          <div className="stick_header w-[115px] flex-shrink-0">
                            <p className="text-[13px] font-[500] text-[#495159] mb-[17px]">
                              Tenor (Years)
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] mb-[20px]">
                              Availability
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] flex items-center">
                              Commission
                            </p>
                          </div>
                          <div className="flex scBarHidden w-[950px] overflow-x-scroll gap-[25px]">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
                              return (
                                <div
                                  className="text-center dealer_com w-[95px]"
                                  key={it}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <p className="text-[#495159] mb-[12px] text-[13px] font-[500]">
                                      {it}
                                    </p>
                                    {CheckPropertinChanges(
                                      notification?.loginfo?.changes?.schedule,
                                      it
                                    ) && (
                                        <p className="text-[#e61034] mb-[12px] text-[15px] font-[500]">
                                          *
                                        </p>
                                      )}
                                  </div>
                                  <Popconfirm
                                    title="Want to edit this?"
                                    okText="Edit"
                                    cancelText="Cancel"
                                    icon={
                                      <BorderColorOutlined
                                        className="mr-[10px]"
                                        fontSize={"small"}
                                        htmlColor="#59758a"
                                      />
                                    }
                                    disabled
                                  >
                                    <div
                                      className={`custom_switch`}
                                      style={{
                                        background:
                                          notification?.loginfo[
                                            commissionSegment[notification?.id]
                                          ]?.schedule?.commision_info[
                                            `year${it}_status`
                                          ] === 1
                                            ? ""
                                            : "#afb3b9",
                                      }}
                                    >
                                      <span
                                        className="sw_text"
                                        style={{
                                          marginLeft:
                                            notification?.loginfo[
                                              commissionSegment[
                                              notification?.id
                                              ]
                                            ]?.schedule?.commision_info[
                                              `year${it}_status`
                                            ] === 1
                                              ? ""
                                              : "10px",
                                        }}
                                      >
                                        {notification?.loginfo[
                                          commissionSegment[notification?.id]
                                        ]?.schedule?.commision_info[
                                          `year${it}_status`
                                        ] === 1
                                          ? "AVL"
                                          : "AVL"}
                                      </span>
                                      {notification?.loginfo[
                                        commissionSegment[notification?.id]
                                      ]?.schedule?.commision_info[
                                        `year${it}_status`
                                      ] === 1 ? (
                                        <span className="thumb"></span>
                                      ) : (
                                        <span
                                          className="thumb"
                                          style={{
                                            transform: "translateX(-47px)",
                                          }}
                                        ></span>
                                      )}
                                    </div>
                                  </Popconfirm>
                                  <p className="mt-[15px] text-[#263238] text-[13px] font-[500]">
                                    {notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.schedule?.commision_info[
                                      `year${it}_status`
                                    ] === 1
                                      ? notification?.loginfo[
                                        commissionSegment[notification?.id]
                                      ]?.schedule?.commision_info[
                                      `year${it}_fee`
                                      ]
                                      : "NA"}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Admin Fee
                          {notification?.loginfo?.changes?.schedule
                            ?.adminfee_changes?.length > 0 && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        <div className="flex flex-wrap gap-[15px]">
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.schedule?.admin_fees?.length > 0 ? (
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.schedule?.admin_fees?.map((feeItem, index) => (
                              <div className="p-[10px_13px] rounded-[8px] border border-[#E0E0E0] bg-[#F4F4F4]">
                                <div className="mb-[2px]">
                                  <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                    Fee amount {index + 1}
                                  </span>
                                  <span className="text-[#263238] font-[500] text-[13px]">
                                    ${feeItem?.admin_fee}
                                  </span>
                                </div>
                                <div>
                                  <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                    Loan amount
                                  </span>
                                  <span className="text-[#263238] font-[500] text-[13px]">
                                    $ {feeItem?.minimum_loan_amount}
                                    <span className="mx-[10px]">to</span>$
                                    {feeItem?.maximum_loan_amount}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="flex flex-wrap gap-[20px_12px] mb-2">
                              <h5>No Admin Fees found...!</h5>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Incentive
                          {Object.keys(
                            notification?.loginfo?.changes?.schedule
                          )?.includes("incentive_amount") && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>

                        <p className="text-[#1B252F] text-[13px] font-[500] break-words">
                          {
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.schedule?.commision_info?.incentive_amount
                          }
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.schedule?.commision_info?.incentive_type === 0
                            ? "%"
                            : "$"}
                        </p>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Remarks
                          {Object.keys(
                            notification?.loginfo?.changes?.schedule
                          ).some((str) => str.includes("remarks")) && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => (
                          <p className="text-[#1B252F] text-[13px] font-[500] mb-[5px] break-words">
                            {
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.schedule?.commision_info[`remarks${it}`]
                            }
                          </p>
                        ))}
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Dealer Bonus
                          {notification?.loginfo?.changes?.schedule
                            ?.dealer_bonuses_changes?.length > 0 && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>

                        {notification?.loginfo[
                          commissionSegment[notification?.id]
                        ]?.schedule?.dealer_bonuses?.length > 0 ? (
                          notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.schedule?.dealer_bonuses?.map((bonus, index) => (
                            // <div className="flex flex-wrap gap-[20px_12px] mb-2">
                            //   <div className="w-full max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
                            //     <div className="bg-[#0E085C] text-white flex flex-col items-center justify-center relative w-[140px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
                            //       <div className="absolute top-[8px] left-[8px]">
                            //         <img src="/images/fi_info_wh.svg" />
                            //       </div>
                            //       <h3 className="font-[800] text-[20px] leading-[25px] tracking-[-1px]">
                            //         {bonus?.bonusinfo?.bonus}%
                            //       </h3>
                            //       <span className="text-[10px] font-[400]">
                            //         Bonus Amount
                            //       </span>
                            //     </div>
                            //     <div className="p-[17px_27px_3px_27px] flex-[1]">
                            //       <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">
                            //         {bonus?.bonusinfo?.name}
                            //       </h3>
                            //       <div className="flex flex-wrap items-center justify-between gap-[15px_30px] mb-[14px]">
                            //         <div>
                            //           <label className="text-[#787486] text-[13px] block mb-[5px]">
                            //             Bonus Program Valid Period
                            //           </label>
                            //           <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
                            //             <img
                            //               src="/images/fi_calendar.svg"
                            //               className="mr-[5px]"
                            //             />
                            //             {moment(bonus?.bonusinfo?.startDate)
                            //               .format("DD MMM YYYY")
                            //               .toUpperCase()}
                            //             <span className="mx-[7px]">to</span>
                            //             {moment(bonus?.bonusinfo?.endDate)
                            //               .format("DD MMM YYYY")
                            //               .toUpperCase()}
                            //           </p>
                            //         </div>
                            //         <div className="min-w-[230px] max-w-full">
                            //           <label className="text-[#787486] text-[13px] block mb-[5px]">
                            //             Qualifying loan amount
                            //           </label>
                            //           <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                            //             ${bonus?.bonusinfo?.minimum_loan_amount}
                            //             <span className="mx-[7px]">to</span>$
                            //             {bonus?.bonusinfo?.maximum_loan_amount}
                            //           </p>
                            //         </div>
                            //         <div>
                            //           <label className="text-[#787486] text-[13px] block mb-[5px]">
                            //             Qualifying period & Payout
                            //           </label>
                            //           <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                            //             Calendar Week payout within{" "}
                            //             {bonus?.bonusinfo?.payout_days} days
                            //             after end of qualifying period
                            //           </p>
                            //         </div>
                            //       </div>
                            //     </div>
                            //   </div>
                            // </div>
                            <BonusCard bonus={bonus?.bonusinfo} />
                          ))
                        ) : (
                          <div className="flex flex-wrap gap-[20px_12px] mb-2">
                            <h5>No Dealer Bonus found...!</h5>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {notification?.is_updated === 1 &&
            notification?.notification_type === "agent_commision" &&
            notification.loginfo?.changes?.schedule === undefined && (
              <div className="border-b border-[#EAEAEA]">
                <div className="p-[26px]">
                  <div className="flex items-center gap-[10px_40px] mb-[15px]">
                    <div className="flex items-center gap-[13px]">
                      <div className="h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]">
                        <img
                          src={`https://api.ohhto.com/${notification?.iteminfo?.icon}`}
                          className="object-cover h-full w-full"
                        />
                      </div>
                      <h3 className="text-black text-[13px] font-[600]">
                        {notification?.iteminfo?.name}
                      </h3>
                    </div>
                    <div className="p-[6px_20px] text-[#0560FB] text-[13px] font-[600] rounded-[4px] bg-[#DDEAFF]">
                      Dealer Comm. Changes
                    </div>
                  </div>
                  <div className="flex items-center gap-[11px] flex-wrap">
                    {notification?.iteminfo?.displaytabs?.length > 0 &&
                      notification?.iteminfo?.displaytabs?.map((item) =>
                        GetCategory(item?.type, item?.name)
                      )}
                  </div>
                </div>
                <div className="pl-[27px]">

                </div>

                <div className="px-[27px] mt-[40px] max-[600px]:px-[0px]">


                  <Segmented
                    className="intTabSeg"
                    options={[
                      { label: "After", value: "after_update" },
                      { label: "Before", value: "before_update" },
                    ]}
                    onChange={(value) => {
                      setCommissionSegment({
                        ...commissionSegment,
                        [notification?.id]: value,
                      });
                    }}
                  />
                  <div className="border border-[#DEDEDE] mb-[40px]">
                    <div className="p-[18px_23px] bg-[#F9FBFD] border-b border-[#DEDEDE]">
                      <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">


                        <div className="rounded-[6px] min-w-[116px] bg-white p-[12px] pb-[6px] text-center">
                          <h3 className="text-[#787486] font-[500] text-[12px]">
                            {notification.iteminfo?.agentCommision !==
                              undefined &&
                              notification.iteminfo?.agentCommision?.is_ht === 1
                              ? "High Tier"
                              : notification.iteminfo?.agentCommision?.is_lt ===
                                1
                                ? "Low Tier"
                                : "Interest Rate"}
                          </h3>
                          <span className="inline-block text-[25px] font-[800] text-[#263238]">
                            {
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.commision_info?.interestinfo?.interest
                            }{" "}
                            %
                          </span>
                        </div>
                        <div className="flex-[1]">
                          <div>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Available from:
                              <strong className="ml-[5px] font-[600]">
                                {moment(
                                  notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.commision_info?.interestinfo?.startDate
                                )
                                  .format("DD MMM YYYY")
                                  .toUpperCase()}{" "}
                                { }
                                <span className="mx-[6px]">to</span>{" "}
                                {notification?.loginfo[
                                  commissionSegment[notification?.id]
                                ]?.commision_info?.interestinfo?.endDate !==
                                  null
                                  ? moment(
                                    notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.commision_info?.interestinfo?.endDate
                                  )
                                    .format("DD MMM YYYY")
                                    .toUpperCase()
                                  : "Further Notice"}
                              </strong>
                            </p>
                            <p className="text-[12px] mb-[5px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                              <img
                                src="/images/fi_calendar.svg"
                                alt="calendar"
                                className="mr-[5px]"
                              />
                              Min. Loan:
                              {notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.commision_info?.interestinfo
                                ?.minimum_loan_amount !== 0 ? (
                                <strong className="ml-[5px] font-[600]">
                                  $
                                  {notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.commision_info?.interestinfo?.minimum_loan_amount.toFixed(
                                    2
                                  )}{" "}
                                  else<span className="mx-[6px]">+</span>
                                  admin fee $
                                  {
                                    notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.commision_info?.interestinfo?.admin_fee
                                  }
                                </strong>
                              ) : (
                                <strong className="ml-[5px] font-[600]">
                                  No min. loan required{" "}
                                </strong>
                              )}
                            </p>
                            <div>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                {
                                  notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.commision_info?.interestinfo?.remarks1
                                }
                              </p>
                              <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">
                                {
                                  notification?.loginfo[
                                    commissionSegment[notification?.id]
                                  ]?.commision_info?.interestinfo?.remarks2
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="p-[24px_30px_24px_30px] singleLoanTab">
                      <div className="flex flex-wrap items-center mt-[10px] gap-[0px_10px] cus_date_pick mb-[27px]">
                        <label className="flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]">
                          Publish Date
                          <img
                            src="/images/fi_info.svg"
                            alt="info"
                            className="inline-block ml-[8px]"
                          />
                        </label>
                        <div className="text-[13px] font-[500] flex">
                          {moment(
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.commision_info?.startDate
                          ).format("DD-MM-YYYY")}
                          {notification?.loginfo?.changes?.startDate ===
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.commision_info?.startDate && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </div>
                        <span className="mx-[10px] text-[13px]">
                          To
                        </span>
                        <div className="text-[13px] font-[500] flex">
                          {" "}
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.commision_info?.endDate
                            ? moment(
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.commision_info?.endDate
                            ).format("DD-MM-YYYY")
                            : "Further Notice"}
                          {notification?.loginfo?.changes?.endDate ===
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.commision_info?.endDate && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Dealer Commission Rates
                          {notification?.loginfo?.changes?.
                            commision_info !== undefined && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        <div className="flex mt-[16px] gap-[8px] relative">
                          <div className="stick_header w-[115px] flex-shrink-0">
                            <p className="text-[13px] font-[500] text-[#495159] mb-[17px]">
                              Tenor (Years)
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] mb-[20px]">
                              Availability
                            </p>
                            <p className="text-[13px] font-[500] text-[#495159] flex items-center">
                              Commission
                            </p>
                          </div>
                          <div className="flex scBarHidden w-[950px] overflow-x-scroll gap-[25px]">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
                              return (
                                <div
                                  className="text-center dealer_com w-[95px]"
                                  key={it}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <p className="text-[#495159] mb-[12px] text-[13px] font-[500]">
                                      {it}
                                    </p>
                                    {CheckPropertinChanges(
                                      notification?.loginfo?.changes,
                                      it
                                    ) && (
                                        <p className="text-[#e61034] mb-[12px] text-[15px] font-[500]">
                                          *
                                        </p>
                                      )}
                                  </div>
                                  <Popconfirm
                                    title="Want to edit this?"
                                    okText="Edit"
                                    cancelText="Cancel"
                                    icon={
                                      <BorderColorOutlined
                                        className="mr-[10px]"
                                        fontSize={"small"}
                                        htmlColor="#59758a"
                                      />
                                    }
                                    disabled
                                  >
                                    <div
                                      className={`custom_switch`}
                                      style={{
                                        background:
                                          notification?.loginfo[
                                            commissionSegment[notification?.id]
                                          ]?.commision_info[
                                            `year${it}_status`
                                          ] === 1
                                            ? ""
                                            : "#afb3b9",
                                      }}
                                    >
                                      <span
                                        className="sw_text"
                                        style={{
                                          marginLeft:
                                            notification?.loginfo[
                                              commissionSegment[
                                              notification?.id
                                              ]
                                            ]?.commision_info[
                                              `year${it}_status`
                                            ] === 1
                                              ? ""
                                              : "10px",
                                        }}
                                      >
                                        {notification?.loginfo[
                                          commissionSegment[notification?.id]
                                        ]?.commision_info[
                                          `year${it}_status`
                                        ] === 1
                                          ? "AVL"
                                          : "AVL"}
                                      </span>
                                      {notification?.loginfo[
                                        commissionSegment[notification?.id]
                                      ]?.commision_info[`year${it}_status`] ===
                                        1 ? (
                                        <span className="thumb"></span>
                                      ) : (
                                        <span
                                          className="thumb"
                                          style={{
                                            transform: "translateX(-47px)",
                                          }}
                                        ></span>
                                      )}
                                    </div>
                                  </Popconfirm>
                                  <p className="mt-[15px] text-[#263238] text-[13px] font-[500]">
                                    {notification?.loginfo[
                                      commissionSegment[notification?.id]
                                    ]?.commision_info[`year${it}_status`] === 1
                                      ? notification?.loginfo[
                                        commissionSegment[notification?.id]
                                      ]?.commision_info[`year${it}_fee`]
                                      : "NA"}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Admin Fee
                          {notification?.loginfo?.changes?.adminfee_changes
                            ?.length > 0 && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        <div className="flex flex-wrap gap-[15px]">
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.admin_fees?.length > 0 ? (
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.admin_fees?.map((feeItem, index) => (
                              <div className="p-[10px_13px] rounded-[8px] border border-[#E0E0E0] bg-[#F4F4F4]">
                                <div className="mb-[2px]">
                                  <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                    Fee amount {index + 1}
                                  </span>
                                  <span className="text-[#263238] font-[500] text-[13px]">
                                    ${feeItem?.admin_fee}
                                  </span>
                                </div>
                                <div>
                                  <span className="text-[#787486] font-[500] text-[13px] mr-[15px]">
                                    Loan amount
                                  </span>
                                  <span className="text-[#263238] font-[500] text-[13px]">
                                    $ {feeItem?.minimum_loan_amount}
                                    <span className="mx-[10px]">to</span>$
                                    {feeItem?.maximum_loan_amount}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="flex flex-wrap gap-[20px_12px] mb-2">
                              <h5>No Admin Fees found...!</h5>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Incentive
                          {Object.keys(
                            notification?.loginfo?.changes
                          )?.includes("incentive_amount") && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>

                        <p className="text-[#1B252F] text-[13px] font-[500] break-words">
                          {
                            notification?.loginfo[
                              commissionSegment[notification?.id]
                            ]?.commision_info?.incentive_amount
                          }
                          {notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.commision_info?.incentive_type === 0
                            ? "%"
                            : "$"}
                        </p>
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Remarks
                          {Object.keys(notification?.loginfo?.changes).some(
                            (str) => str.includes("remarks")
                          ) && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => (
                          <p className="text-[#1B252F] text-[13px] font-[500] mb-[5px] break-words">
                            {
                              notification?.loginfo[
                                commissionSegment[notification?.id]
                              ]?.commision_info[`remarks${it}`]
                            }
                          </p>
                        ))}
                      </div>
                      <div className="mb-[27px]">
                        <label className="text-[#27272B] font-[700] text-[13px] mb-[10px] flex">
                          Dealer Bonus
                          {notification?.loginfo?.changes
                            ?.dealer_bonuses_changes?.length > 0 && (
                              <p className="text-[#e61034] ml-[15px] text-[15px] font-[500]">
                                *
                              </p>
                            )}
                        </label>

                        {notification?.loginfo[
                          commissionSegment[notification?.id]
                        ]?.dealer_bonuses?.length > 0 ? (
                          notification?.loginfo[
                            commissionSegment[notification?.id]
                          ]?.dealer_bonuses?.map((bonus, index) => (
                            <div className="flex flex-wrap gap-[20px_12px] mb-2">
                              {/* <div className="w-full max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
                                <div className="bg-[#0E085C] text-white flex flex-col items-center justify-center relative w-[140px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
                                  <div className="absolute top-[8px] left-[8px]">
                                    <img src="/images/fi_info_wh.svg" />
                                  </div>
                                  <h3 className="font-[800] text-[20px] leading-[25px] tracking-[-1px]">
                                    {bonus?.bonusinfo?.bonus}%
                                  </h3>
                                  <span className="text-[10px] font-[400]">
                                    Bonus Amount
                                  </span>
                                </div>
                                <div className="p-[17px_27px_3px_27px] flex-[1]">
                                  <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">
                                    {bonus?.bonusinfo?.name}
                                  </h3>
                                  <div className="flex flex-wrap items-center justify-between gap-[15px_30px] mb-[14px]">
                                    <div>
                                      <label className="text-[#787486] text-[13px] block mb-[5px]">
                                        Bonus Program Valid Period
                                      </label>
                                      <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
                                        <img
                                          src="/images/fi_calendar.svg"
                                          className="mr-[5px]"
                                        />
                                        {moment(bonus?.bonusinfo?.startDate)
                                          .format("DD MMM YYYY")
                                          .toUpperCase()}
                                        <span className="mx-[7px]">to</span>
                                        {moment(bonus?.bonusinfo?.endDate)
                                          .format("DD MMM YYYY")
                                          .toUpperCase()}
                                      </p>
                                    </div>
                                    <div className="min-w-[230px] max-w-full">
                                      <label className="text-[#787486] text-[13px] block mb-[5px]">
                                        Qualifying loan amount
                                      </label>
                                      <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                                        ${bonus?.bonusinfo?.minimum_loan_amount}
                                        <span className="mx-[7px]">to</span>$
                                        {bonus?.bonusinfo?.maximum_loan_amount}
                                      </p>
                                    </div>
                                    <div>
                                      <label className="text-[#787486] text-[13px] block mb-[5px]">
                                        Qualifying period & Payout
                                      </label>
                                      <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
                                        Calendar Week payout within{" "}
                                        {bonus?.bonusinfo?.payout_days} days
                                        after end of qualifying period
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                               */}
                              <BonusCard bonus={bonus?.bonusinfo} />
                            </div>
                          ))
                        ) : (
                          <div className="flex flex-wrap gap-[20px_12px] mb-2">
                            <h5>No Dealer Bonus found...!</h5>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </>
      ))}
    </div>
  ) : (
    <div className="flex-[1] w-[600px]">
      <div className="flex justify-between items-center p-[17px_26px] border-b border-[#EAEAEA] mt[300px]">
        No Notifications Found..!
      </div>
    </div>
  );
};

export default NotificationContent;
